import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavService } from '@reenstudio/app/core/services/nav.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '@reenstudio/app/material.module';
import { RouterModule } from '@angular/router';
import { AppNavItemComponent } from './nav-item/nav-item.component';
import { AuthService } from '@reenstudio/app/core/services/auth.service';
import { StorageService } from '@reenstudio/app/core/services/storage.service';
import { WeatherComponent } from '@reenstudio/app/shared/components/weather/weather.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    RouterModule,
    AppNavItemComponent,
    CommonModule,
    WeatherComponent,
  ],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  navopt = this.navService.showClass;
  nameUser: string | null;
  weatherType: string = 'sideBar';

  constructor(
    public navService: NavService,
    private authService: AuthService,
    private storageService: StorageService
  ) {
    this.nameUser = this.storageService.getName();
  }

  ngOnInit(): void {}

  logout() {
    this.authService.signOut();
  }
}
